import { CustomBox } from "components";
import { ExpiredSubscriptionIcon } from "pages/internal-dashboard/icons";
import { getGrowthTrends } from "../../helpers";

export function UsersWithExpiredSubscription({ data, isLoading }: any) {
  const {
    today = 0,
    thisWeek = 0,
    thisMonth = 0,
    thisYear = 0,
    total = 0,
  } = data || {};

  const growthTrends = getGrowthTrends(data);

  return (
    <CustomBox
      loading={isLoading}
      color="#BFD0F2"
      title="Users with expired subscriptions"
      userCount={total}
      boxData={{
        label: "Expired Subscriptions",
        description:
          "Users whose subscription period has ended and have not yet renewed.",
        todayCount: today,
        weekCount: thisWeek,
        monthCount: thisMonth,
        yearCount: thisYear,
        icon: ExpiredSubscriptionIcon,
      }}
      percentages={growthTrends}
    />
  );
}
